// extracted by mini-css-extract-plugin
export var article = "style-module--article--8db0d";
export var chronogical = "style-module--chronogical--de080";
export var circle = "style-module--circle--33baa";
export var circleContainer = "style-module--circleContainer--e4bc9";
export var description = "style-module--description--a5b1d";
export var en = "style-module--en--e5837";
export var featureDetail = "style-module--featureDetail--1ab4f";
export var image = "style-module--image--b14c7";
export var index = "style-module--index--91ece";
export var indexContainer = "style-module--indexContainer--ec301";
export var link = "style-module--link--87d6a";
export var main = "style-module--main--8a6c3";
export var name = "style-module--name--31120";
export var number = "style-module--number--4a530";
export var profile = "style-module--profile--6afb3";
export var profileImage = "style-module--profileImage--32e37";
export var selector = "style-module--selector--8b10f";
export var subTitle = "style-module--subTitle--38b0b";
export var title = "style-module--title--c0a4c";
export var titleContainer = "style-module--titleContainer--689da";